<template>
  <div class="not-found">
    <div>
      <p>未找到页面</p>
    </div>

  </div>
</template>
<script>
export default {
  mounted() {
  },
  methods: {
  },
};
</script>
<style lang="less">
  .not-found {
    position: absolute;
    text-align: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      margin-top: 20px;
    }

    img {
      width: 40px;
    }
  }
</style>
